export const baseUrl = import.meta.env.VITE_API_URL;
const  ApiConfig = {
  getCosCred :"/api/cos-cred",
  getCosPathKey :"/api/upload-path",
  getOssCred :"/api/misc/cos-token",
  getOssPathKey :"/api/oss-upload-path",

  loginIn :"/api/user/login",
  signUp :"/api/user/register",
  verificationMailbox :"/api/user/login/otp/email", // get
  forgetPassword :"/api/user/password/lost",
  resetPasswordAuth :"/api/user/password",
  resetPassword :"/api/user/pwd/reset",
  loginOut :"/api/user/logout",
  getUserInfo :"/api/ai/user/profile",
  sendEmail: "/api/user/login/otp/emai",
  getConfig: "/api/config",

  getShareData:'/api/sm/share/detail',
  /// 获取草稿
  getDraftData: '/api/ugc/draft/query',
  /// 保存参考伴奏并反解析prompt
  saveReferenceMusic:'/api/ugc/accompany/refer/save',
  addReferenceMusic: '/api/ugc/accompany/refer/upload',
  saveLinkSpider: "/api/ugc/refer/link",
  getLinkSpider: "/api/ugc/refer/link/get",
  deleteLinkSpider: "/api/ugc/refer/link/delete",

  getEditorsPicksData: '/api/sm/preferred/list',
 
  getEditorsPickLatestDatas: '/api/sm/latest/list',
  deleteReferMusicItem:'/api/ugc/accompany/refer/history/delete',
  /// 保存参考伴奏并反解析prompt,不保存
  saveReferenceMusicTmp:'/api/ugc/parse/music_link',
  /// 删除参考伴奏
  deleteReferenceMusic :'/api/ugc/accompany/refer/delete',
  /// 保存伴奏prompt
  saveAccompanyPrompt: '/api/ugc/accompany/prompt/update',
  /// 随机获取伴奏prompt模版
  randomAccompanyPrompt: '/api/ugc/accompany/prompt/random',
  /// 查询歌曲详情可下载格式
  feedCardDownloadQuery: '/api/ugc/generate/download/query',
  /// 下载生成的歌曲/伴奏
  feedCardDownloadReport: "/api/ugc/generate/download",
  /// 分享生成的歌曲/伴奏
  feedCardShareReport: "/api/ugc/detail/share",
  /// 重新编辑当前feed restore
  reEditCurFeedDraft: '/api/ugc/generate/feed/copy',
  /// 重新尝试生成当前feed
  feedCardRetryGenerate: '/api/ugc/feed/generate/retry',
  /// 取消生成
  feedCardCancelGenerate: '/api/ugc/feed/generate/cancel',
  /// 生成音乐
  feedCardGenerate:  '/api/ugc/feed/generate', // '/api/ugc/feed/generate',
  /// 生成音乐相似
  feedCardGenerateSimilar: '/api/ugc/feed/generate/similar',
  /// sse 获取生成音乐状态 
  sseGetGenerate: '/api/sse/subscribe',
  /// 获取feed列表
  getFeedList: '/api/ugc/generate/feed/query',
  /// 获取歌曲详情
  getLibraryList :'/api/ugc/accompany/refer/query',
 
  // 查询参考音乐
  getReferMusics: '/api/ugc/accompany/refer/query',

  /// 1.0.2 歌曲编辑相关api
  /// 获取歌曲详情
  musicDetail :"/api/ugc/card/music/detail",
  /// 改音调
  modifyKey :"/api/ugc/key/change",
  /// 修改bpm
  modifyBpm :"/api/ugc/bpm/change",
  /// 保存，覆盖编辑内容
  save :"/api/ugc/ai/save",
  /// 导出
  export :"/api/ugc/ai/export",
  /// 和声生成
  harmonyGen :"/api/ugc/change/backing_vocal",
  /// 主唱生成
  leadVocalGen :"/api/ugc/card/vocal/generate",
  /// 新旋律、新歌词、新配器、新主唱、新和声、新调、新bpm后，点击use按钮时，调本接口，应用本次变更
  applyModify :"/api/ugc/ai/apply",
  /// 分页查询艺人列表
  artistList :"/api/ugc/artist/list",
  /// 生成新旋律
  newMelody :"/api/ugc/card/melody/generate",
  /// 歌词美化生成
  lyricPolishGenerate :"/api/ugc/card/polish/generate",
  /// 全局重新生成
  reGenerate :"/api/ugc/card/generate",
  /// 歌词美化
  lyricPolish :"/api/sse/ugc/lyrics/polish",
  /// 歌词续写
  lyricExtend :"/api/sse/ugc/lyrics/extend",
  /// sku list
  payment : "/api/payment/channels/shareit/normal/products",
  /// 获取支付链接
  purchaseEntry : "/api/payment/shareit/purchase-entry",
  /// 多语言
  language: "/api/ugc/language/switch",
  /// 配置接口
  config: "/api/config",

  getTopicDatas: '/api/sm/home/banner',
  // 我的作品列表
  getMyworkList: '/api/ugc/generate/feed/query'
}

export default ApiConfig;